import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class ApplicationController extends Controller {
  @tracked response: string = '';
  constructor() {
    super(...arguments);
    this.getResponse();
  }
  @action
  async getResponse() {
    const response = await fetch('/api/resp');
    await timeout(400);

    const data = await response.text();
    this.response = data;
  }
}

function timeout(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
